export default "__VITE_ASSET__B5Z6LCsj__"